import { Tin } from "./Tin";
export class SpanishTin extends Tin {
    validateNumberTin(tin) {
        if (!/^\d{1,8}[A-Z]$/.test(tin)) {
            return false;
        }
        const paddedTin = ("000000000" + tin).slice(-9);
        const number = parseInt(paddedTin.slice(0, 8), 10);
        const reminder = number % 23;
        const lookup = "TRWAGMYFPDXBNJZSQVHLCKE".split("");
        return paddedTin.slice(-1) === lookup[reminder];
    }
    validateLetterTin(tin) {
        if (!/^[XYZKLM]\d{7}[A-Z]$/.test(tin)) {
            return false;
        }
        const replacements = {
            X: 0,
            Y: 1,
            Z: 2,
            K: 0,
            L: 0,
            M: 0,
        };
        const numberTin = replacements[tin[0]] + tin.slice(1);
        return this.validateNumberTin(numberTin);
    }
    validate(tin) {
        tin = tin.toLocaleUpperCase().replaceAll("-", "").trim();
        return this.validateNumberTin(tin) || this.validateLetterTin(tin);
    }
    getNormalizedTin() {
        return this.tin.toLocaleUpperCase().replaceAll("-", "").trim();
    }
    getBirthDate() {
        return undefined;
    }
}
